import Sveip from '@nrk/dh-basis-sveip'
import { connectScrollContainerLazyLoad } from '@nrk/dh-basis-common'

export class SexguidenSveip extends Sveip {
  _disconnectLazyLoad
  connectedCallback() {
    super.connectedCallback()
    this._disconnectLazyLoad = connectScrollContainerLazyLoad(
      this.scrollContainer,
      this.querySelectorAll('img')
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this._disconnectLazyLoad()
  }
}
